export default __webpack_public_path__ + "static/media/ENGLISH_WRITING.72af0e72.svg";